/******************************************************************
Custom scripts for customers area (order viewing, upgrading, downgrading)
******************************************************************/
(function() {
    initQuiz();
})();

function randomIntFromInterval(min, max) { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/* function to prep the screen for the possible changes to the products in the order */
function initQuiz() {

    const QS = new URLSearchParams(document.location.search);
    const KLAVIYO_PROFILE_ID = QS.get("pid") || "";
    const KLAVIYO_SITE_ID = "8S7f64";

    const klaviyoTrack = (step, extra) => {
        if(KLAVIYO_PROFILE_ID?.length > 0 && KLAVIYO_PROFILE_ID.indexOf("{") < 0) {
            fetch(`https://a.klaviyo.com/client/events?company_id=${KLAVIYO_SITE_ID}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "revision": "2024-10-15"
                },
                body: JSON.stringify({
                    "data": {
                      "type": "event",
                      "attributes": {
                        "properties": {
                          "step": step,
                          "extra": extra
                        },
                        "metric": {
                          "data": {
                            "type": "metric",
                            "attributes": {
                                "name": "PR Quiz Step"
                            }
                          }
                        },
                        "profile": {
                          "data": {
                            "type": "profile",
                            "id": KLAVIYO_PROFILE_ID,
                            "attributes": {
                              "properties": {
                                "anonymous_id": KLAVIYO_PROFILE_ID
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            });
        }
    };

    const prSizePricingGrid = {
        "12x12-Lap": {
            discount: 20,
            discountPercent: 30,
            retail: 75,
            squares: 16,
            discountCode: "prqlap"
        },
        "12x12-Lap-Double Sided": {
            discount: 20,
            discountPercent: 30,
            retail: 99,
            squares: 16,
            discountCode: "prqlap"
        },
        "12x12-Twin": {
            discount: 20,
            discountPercent: 30,
            retail: 109.99,
            squares: 24,
            discountCode: "prqtwin"
        },
        "12x12-Twin-Double Sided": {
            discount: 20,
            discountPercent: 30,
            retail: 129.99,
            squares: 24,
            discountCode: "prqtwin"
        },
        "12x12-Full": {
            discount: 25,
            discountPercent: 30,
            retail: 139.99,
            squares: 30,
            discountCode: "prqfull"
        },
        "12x12-Full-Double Sided": {
            discount: 25,
            discountPercent: 30,
            retail: 179.99,
            squares: 30,
            discountCode: "prqfull"
        },
        "12x12-Large Throw": {            
            discount: 30,
            discountPercent: 30,
            retail: 159.99,
            squares: 36,
            discountCode: "prqlt"
        },
        "12x12-Large Throw-Double Sided": {
            discount: 30,
            discountPercent: 30,
            retail: 209.99,
            squares: 30,
            discountCode: "prqlt"
        },
        "12x12-Queen": {
            discount: 40,
            discountPercent: 30,
            retail: 199.99,
            squares: 42,
            discountCode: "prqqueen"
        },
        "12x12-Queen-Double Sided": {
            discount: 40,
            discountPercent: 30,
            retail: 299.99,
            squares: 30,
            discountCode: "prqqueen"
        },
        "12x12-King": {
            discount: 40,
            discountPercent: 30,
            retail: 249.99,
            squares: 64,
            discountCode: "prqking"
        },
        "12x12-King-Double Sided": {
            discount: 40,
            discountPercent: 30,
            retail: 359.99,
            squares: 30,
            discountCode: "prqking"
        },
        "14x14-Lap": {
            discount: 20,
            discountPercent: 30,
            retail: 89.99,
            squares: 16,
            discountCode: "prqlap"
        },
        "14x14-Lap-Double Sided": {
            discount: 20,
            discountPercent: 30,
            retail: 114.99,
            squares: 16,
            discountCode: "prqlap"
        },
        "14x14-Twin": {
            discount: 20,
            discountPercent: 30,
            retail: 129.99,
            squares: 24,
            discountCode: "prqtwin"
        },
        "14x14-Twin-Double Sided": {
            discount: 20,
            discountPercent: 30,
            retail: 139.99,
            squares: 24,
            discountCode: "prqtwin"
        },
        "14x14-Full": {
            discount: 25,
            discountPercent: 30,
            retail: 159.99,
            squares: 30,
            discountCode: "prqfull"
        },
        "14x14-Full-Double Sided": {
            discount: 25,
            discountPercent: 30,
            retail: 199.99,
            squares: 30,
            discountCode: "prqfull"
        },
        "14x14-Large Throw": {
            discount: 30,
            discountPercent: 30,
            retail: 189.99,
            squares: 36,
            discountCode: "prqlt"
        },
        "14x14-Large Throw-Double Sided": {
            discount: 30,
            discountPercent: 30,
            retail: 239.99,
            squares: 36,
            discountCode: "prqlt"
        },
        "14x14-Queen": {
            discount: 40,
            discountPercent: 30,
            retail: 239.99,
            squares: 42,
            discountCode: "prqqueen"
        },
        "14x14-Queen-Double Sided": {
            discount: 40,
            discountPercent: 30,
            retail: 289.99,
            squares: 42,
            discountCode: "prqqueen"
        },
        "14x14-King": {
            discount: 40,
            discountPercent: 30,
            retail: 299.99,
            squares: 64,
            discountCode: "prqking"
        },
        "14x14-King-Double Sided": {
            discount: 40,
            discountPercent: 30,
            retail: 389.99,
            squares: 42,
            discountCode: "prqking"
        }
    };
  	
    const selectVariant = function(product, option1, option2, option3) {
        let variantInfo = null;
        for(prodVar of product.variants) {                    
            if(prodVar.option1 == option1 && prodVar.option2 == option2 && prodVar.option3 == option3) {
                variantInfo = prodVar;
                variantInfo.lifestyleImage = selectImage(product.images,option2.toLowerCase().replace(/ /g,'-'));
                break;
            }
        }  
        return variantInfo;      
    };

    const selectImage = function(images, size) {
        const lifestyleImages = images.filter(image => image.includes(`lifestyle-${size}`));
        if(lifestyleImages.length > 1) {
            return lifestyleImages[1];
        }
        else if(lifestyleImages.length > 0) {
            return lifestyleImages[0];
        }
        return null;
    };

    /* RepatPro Wizard */
    (() => {

        let quiltSize = null;
        let panelSize = "12x12";
        let color = null;
        let pricing = null;
        let thisVariant = null;

        const windowScroll = (elem) => {
            if(true || window.innerWidth < 768) {
                window.scrollTo({
                    top: elem.offsetTop,
                    behavior: 'smooth' 
                });
            }
        };

        const sizeChoose = () => {
            $(".size-guide-img").hide();
            if(quiltSize && panelSize) {                
                const panelQuilt = `${panelSize}-${quiltSize}`;
                const panelQuiltColor = color ? `${panelSize}-${quiltSize}-${color}` : null;
                if(panelQuilt in prSizePricingGrid) {  
                    $(`.change-swatches [data-value="${panelSize}"]`).click();
                    $(`.change-swatches [data-value="${quiltSize}"]`).click();
                    $(".pr-wizard-quilt-size").text(quiltSize);
                    $(".pr-wizard-panel-size").text(panelSize);                    

                    pricing = (panelQuiltColor && color == "Double Sided" && panelQuiltColor in prSizePricingGrid) ? prSizePricingGrid[panelQuiltColor] : prSizePricingGrid[panelQuilt];
                    if("discountPercent" in pricing) {
                        const discountAmount = Math.trunc(pricing.retail * (pricing.discountPercent / 100) * 100) / 100;
                        $(".pr-wizard-sizing-pricing-price").text((pricing.retail-discountAmount).toFixed(2));
                    } else {
                        $(".pr-wizard-sizing-pricing-price").text((pricing.retail-pricing.discount).toFixed(2));
                    }
                    $(".pr-wizard-sizing-pricing-retail").text(pricing.retail);                    
                    if(panelSize == "12x12") {
                        $(".size-guide-12").show();
                    } else {
                        $(".size-guide-14").show();
                    }
                    thisVariant = selectVariant(QUILT_PROD, panelSize, quiltSize, "Navy Blue");
                    $(".pr-wizard-quilt-image img").attr("src", thisVariant.lifestyleImage);
                    window.setTimeout(function() {
                        $(".slick-list").css("height", "auto");
                    }, 2000);
                }
                $(".slick-list").css("height", "auto");                    
            }
        };

        const quiltSizeSelect = (selectedSize) => {
            quiltSize = selectedSize != "" ? selectedSize : null;            
            if(quiltSize) {
                sizeChoose();
                $(".pr-wizard-step-quilt-size .pr-wizard-step-answer").show();                                
                const quiltViewElem = document.querySelector(".pr-wizard-step-quilt-size .pr-wizard-step-answer");
                windowScroll(quiltViewElem);
                $(".slick-list").css("height", "auto");
                klaviyoTrack("Quilt Selection", quiltSize);
                gtag('event', 'prquiz', {
                    quiz_step: "Quilt Selection"
                });
            }
        };

        const panelSizeSelect = (selectedSize) => {
            panelSize = selectedSize != "" ? selectedSize : null;
            if(panelSize) {
                sizeChoose();
                $(".pr-wizard-step-panel-size .pr-wizard-step-answer").show();
                const quiltViewElem = document.querySelector(".pr-wizard-step-panel-size .pr-wizard-step-answer");
                windowScroll(quiltViewElem);
                $(".slick-list").css("height", "auto");
                klaviyoTrack("Panel Selection", panelSize);
                gtag('event', 'prquiz', {
                    quiz_step: "Panel Selection"
                });
            }
        };

        const colorSelect = (selectedColor) => {
            color = selectedColor != "" ? selectedColor : null;
            $(".pr-wizard-color-ds").hide();
            if(color) {
                sizeChoose();
                $(`.change-swatches [data-value="${color}"]`).click();
                $(".pr-wizard-color").text(color);
                if(color == "Double Sided") {
                    $(".pr-wizard-color-ds").show();
                }
                $(".pr-wizard-step-color .pr-wizard-step-answer").show();
                const quiltViewElem = document.querySelector(".pr-wizard-step-color .pr-wizard-step-answer");
                windowScroll(quiltViewElem);
                thisVariant = selectVariant(QUILT_PROD, panelSize, quiltSize, color);
                document.getElementById("wizard-variant-add").value = thisVariant.id;
                document.getElementById("wizard-discount-add").value = pricing.discountCode;                
                klaviyoTrack("Color Selection", color);
                gtag('event', 'prquiz', {
                    quiz_step: "Color Selection"
                });
            }
        };

        $("#pr-wizard-slick").slick({
            slidesToShow: 1,
            infinite: false,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            swipe: false,
            swipeToSlide: false,            
            touchMove: false,
            draggable: false         
        });
        $("[data-wizard-go]").on("click", function(e) {
            e.preventDefault();
            window.scrollTo(0,0);
            const nextSlide = Number($(this).data("wizard-go"));
            if(nextSlide == 1) {
                $(".pr-wizard-header").hide();
                $(".pr-wizard-step-quilt-size .pr-wizard-video-container").show();
            }
            $("#pr-wizard-slick").slick("slickGoTo", nextSlide);
        });
        $(".pr-wizard-step-back").on("click", function(e) {
            e.preventDefault();
            window.scrollTo(0,0);
            $("#pr-wizard-slick").slick("slickPrev");
            gtag('event', 'prquiz', {
                quiz_step: "back"
            });
        });
        $(".pr-wizard-sizing-quilt").on("change", function(e) {
            quiltSizeSelect($(this).val());
            $(".pr-wizard-step-panel-size .pr-wizard-video-container").show();
        });
        $(".pr-wizard-sizing-panel").on("change", function(e) {
            panelSizeSelect($(this).val());
            $(".pr-wizard-step-color .pr-wizard-video-container").show();
        });
        $(".pr-wizard-color-select").on("change", function(e) {
            colorSelect($(this).val());
            $(".pr-wizard-step-extras .pr-wizard-video-container").show();
        });
        $(".pr-wizard-selector-box").on("click", function(e) {
            const $parent = $(this).closest(".pr-wizard-selectors");
            const $selectBox = $parent.next(".pr-wizard-select");
            $parent.children(".pr-wizard-selector-box").removeClass("pr-wizard-selector-box-active");
            $(this).addClass("pr-wizard-selector-box-active");
            $selectBox.val($(this).data("select")).trigger("change");
        });
        $(".buy-now-btn").on("click", function(e) {
            klaviyoTrack("Add to Cart", thisVariant.sku);
            gtag('event', 'prquiz', {
                quiz_step: "Add to Cart"                
            });
        });

        gtag('event', 'prquiz', {
            quiz_step: "Start"
        });
        klaviyoTrack("Start","");

    })();
}